"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.listReports = listReports;
const path = __importStar(require("path"));
const dist_1 = require("../../fs/dist");
/** Scan one `reports/` dir, appending each `type: report` doc to `out`. Missing dir = no-op. */
async function collectReports(deps, dir, weaveSlug, out) {
    let files;
    try {
        files = (await deps.fs.readdir(dir)).filter((f) => f.endsWith('.md'));
    }
    catch {
        return; // no reports/ dir here — fine
    }
    for (const file of files) {
        const filePath = path.join(dir, file);
        try {
            const doc = await (0, dist_1.loadDoc)(filePath);
            if (doc.type !== 'report')
                continue;
            out.push({
                id: doc.id ?? file.replace(/\.md$/, ''),
                title: doc.title ?? file.replace(/\.md$/, ''),
                kind: doc.kind ?? 'unknown',
                weaveSlug,
                generated_at: doc.generated_at ?? doc.created ?? null,
                filePath,
            });
        }
        catch {
            // skip malformed / unreadable report docs
        }
    }
}
/**
 * List every report artifact on disk: cross-weave reports under `loom/reports/` and
 * weave-scoped reports under `loom/{weave}/reports/`. Deterministic, newest-first by
 * `generated_at` (title as tiebreak). Pure read — never mutates.
 */
async function listReports(deps) {
    const loomDir = path.join(deps.getActiveLoomRoot(), 'loom');
    const out = [];
    // Cross-weave reports: loom/reports/
    await collectReports(deps, path.join(loomDir, 'reports'), null, out);
    // Weave-scoped reports: loom/{weave}/reports/
    let entries;
    try {
        entries = await deps.fs.readdir(loomDir, { withFileTypes: true });
    }
    catch {
        entries = [];
    }
    for (const entry of entries) {
        if (!entry.isDirectory())
            continue;
        if (entry.name === 'reports' || entry.name === '.archive')
            continue;
        await collectReports(deps, path.join(loomDir, entry.name, 'reports'), entry.name, out);
    }
    out.sort((a, b) => (b.generated_at ?? '').localeCompare(a.generated_at ?? '') ||
        a.title.localeCompare(b.title));
    return out;
}
